import { ItemList } from '../orm'

class PhotographerLedgerList extends ItemList {
    getEntityKey() {
        return "photographer/photographer_ledger/photographer_ledger"
    }
    
}

export const photographerLedgerList = new PhotographerLedgerList("photographer_ledger_default")
